import { type FC, memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'
import type { ChatMessageAttachment } from './chat-message.interface'
import { ChatMessageAttachmentChip } from './chat-message-attachment-chip.atom'

export interface ChatMessageAttachmentListProps {
  attachmentList: ChatMessageAttachment[]
  onDownload?: (attachmentId: string) => void
  className?: string
}

const ChatMessageAttachmentListBase: FC<ChatMessageAttachmentListProps> = ({
  attachmentList,
  onDownload,
  className,
}): ReactNode => {
  if (attachmentList.length === 0) return null

  return (
    <div className={cn('chat-message-attachments flex flex-wrap gap-1.5', className)}>
      {attachmentList.map((attachment) => (
        <ChatMessageAttachmentChip
          key={attachment.id}
          attachment={attachment}
          onDownload={onDownload}
        />
      ))}
    </div>
  )
}

export const ChatMessageAttachmentList = memo(ChatMessageAttachmentListBase)

ChatMessageAttachmentList.displayName = 'ChatMessageAttachmentList'
